/**
 * @module Experience/repdash
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const LINE_LANDING_CONSTANTS = {
  LINE_DETAILS: 'lineDetails',
  INFO: 'info',
  ACCOUNT: 'account',
  LINES: 'lines',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  TMPS: 'TMPS',
  CONTINUE: 'continue',
  SUBMIT: 'submit',
  BUTTON_CLASS: 'btn btn-primary',
  CANCELLED: 'CANCELLED',
  // @TODO: Number should be coming from a centralised repository
  CUSTOMER_CARE_NUMBER: '(800) 937-8997',
  LOST_STOLEN: 'ELSTS',
  PENDING: 'PENDING',
  INPROCESS: 'INPROCESS',
  RECEIVED: 'RECEIVED',
  CHANGESERVICESTATUS: 'CHANGESERVICESTATUS',
  NOTFOUND: 'NOTFOUND',
  MANAGE_RATE_PLAN: 'MANAGERATEPLAN',
  POSTPAID: 'POSTPAID',
  OTHER: 'Other',
  UNBLOCK_MY_IMEI: 'Unblock my IMEI',
  BLOCK_MY_IMEI: 'Block my IMEI',
  LINE_LANDING: '/line-landing',
  ELSTS: 'ELSTS',
  CPS: 'CPS',
  REPDASH_UPDATE_EVENT: 'auditDrawer.updateMsisdn',
  PRIMARY: 'primary',
  NS: 'NS',
  ZERO: '0',
};

export const ORDER_TYPES = [
  'MANAGEADDON',
  'MANAGERATEPLAN',
  'ACTIVATION',
  'ADDALINE',
  'ADDONREDEEM',
];

export const COMMONLANDING_MODULE_COMPONENTS = {
  COMMONLANDING_MODULE_NAME: 'CommonLandingModule',
  ASSISTED_LINELANDING_COMPONENT: 'AssistedLineLandingComponent',
  LINE_LANDING_COMPONENT: 'LineLandingComponent',
  LINE_SELECTOR_COMPONENT: 'LineSelectorComponent',
};
